import { createStore } from 'vuex';
import axios from 'axios';
import Cookies from 'js-cookie';
import blog from './modules/blog';

const ADBOX_API_URL = process.env.VUE_APP_ADBOX_API_URL;
const ADBOX_API_V2_URL = process.env.VUE_APP_ADBOX_API_V2_URL;
export default createStore({
  state: {
    modalIsVisible: null,
    token: null,
    currentUser: null,
    collections: null,
    roles: null,
    advertisements: null,
    page: 0,
    nextPage: 1,
    totalAdvertisements: 999,
    totalTiktoks: 999,
    tiktoks: null,
    ugc_creators: null,
    totalUGC: 100,
    plans: null,
    title_subtitle: null,
    genders: ['Woman', 'Man'],
    totalUserCount: 0,
    all_plans: [
      { label: 'Free', value: 'free' },
      { label: 'Monthly', value: 'monthly' },
      { label: 'Annual', value: 'annual' },
      { label: 'Admin', value: 'admin' },
      { label: 'Super', value: 'super' },
    ],
    ugc_countries: [
      { label: 'Australia', value: 'Australia' },
      { label: 'Canada', value: 'Canada' },
      { label: 'Dominican Republic', value: 'Dominican Republic' },
      { label: 'Finland', value: 'Finland' },
      { label: 'France', value: 'France' },
      { label: 'Germany', value: 'Germany' },
      { label: 'Great Britain', value: 'Great Britain' },
      { label: 'Greece', value: 'Greece' },
      { label: 'Irland', value: 'Irland' },
      { label: 'Italy', value: 'Italy' },
      { label: 'Korea', value: 'Korea' },
      { label: 'Mexico', value: 'Mexico' },
      { label: 'Netherlands', value: 'Netherlands' },
      { label: 'Nigeria', value: 'Nigeria' },
      { label: 'Norway', value: 'Norway' },
      { label: 'Romania', value: 'Romania' },
      { label: 'South Africa', value: 'South Africa' },
      { label: 'Spain', value: 'Spain' },
      { label: 'United States', value: 'United States' },
    ],
    actionsTexts: [
      'Learn More',
      'Apply Now',
      'Book Now',
      'Buy Tickets',
      'Call Now',
      'Contact Us',
      'Donate Us',
      'Download',
      'Get Directions',
      'Get Offer',
      'Get Quote',
      'Get Showtimes',
      'Install Now',
      'Like Page',
      'Listen Now',
      'Open Link',
      'Order Now',
      'Play Game',
      'Request Time',
      'Save',
      'See Menu',
      'Send Message',
      'Send WhatsApp Message',
      'Shop Now',
      'Sign Up',
      'Subscribe',
      'Use App',
      'View Event',
      'Watch More',
    ],
    industries: [
      {
        label: 'Food/Drink',
        value: 'Food/Drink',
        values: ['Drinks', 'Food', 'Other'],
      },
      {
        label: 'Fashion',
        value: 'Fashion',
        values: ['Accesories/jewelry', 'Clothing', 'Footwear', 'Other'],
      },
      { value: 'Health/Wellness', values: ['Suplements', 'Other'] },
      { value: 'Beauty/Cosmetics' },
      {
        value: 'Home',
        values: ['Furniture', 'Decoration', 'Landscaping', 'Other'],
      },
      { value: 'Kids/Baby', values: ['Fashion', 'food and drinks', 'Other'] },
      { value: 'Pets', values: ['Food', 'Accesories', 'Other'] },
      { value: 'Tech', values: ['Electronics'] },
      {
        value: 'Sports/Outdoors',
        values: ['Indoor sports', 'Outdoor sports', 'Fitness', "Sport's clothing", 'Other'],
      },
      { value: 'Other' },
      { label: 'Null', value: 'null' },
    ],
    types: [
      'Unboxing',
      'Lifestyle',
      'Social Proof',
      'Discount',
      'Humor',
      'Ilustration',
      'How-to/Features',
      'UGC',
      'Seasonal',
    ],
    seasonal: [
      'Black Friday',
      'Christmas',
      'Halloween',
      'Thanksgiving',
      'New Year',
      'Summer',
      'Winter',
      'Spring',
      'Fall',
    ],
    objectives: [
      { label: 'Prospecting', value: 'prospecting' },
      { label: 'Retargeting', value: 'retargeting' },
    ],
    filters: {},
  },
  mutations: {
    SET_TOKEN(state, value) {
      state.token = value;
    },
    SET_ADVERTISEMENTS(state, value) {
      if (!value) {
        state.advertisements = null;
      } else {
        if (state.advertisements) state.advertisements = [...state.advertisements, ...value];
        else state.advertisements = value;
      }
    },
    SET_TIKTOKS(state, value) {
      if (!value) {
        state.tiktoks = null;
      } else {
        if (state.tiktoks) state.tiktoks = [...state.tiktoks, ...value];
        else state.tiktoks = value;
      }
    },
    SET_UGC_CREATORS(state, value) {
      if (!value) {
        state.ugc_creators = null;
      } else {
        if (state.ugc_creators) state.ugc_creators = [...state.ugc_creators, ...value];
        else state.ugc_creators = value;
      }
    },
    SET_MEMBERSHIPS(state, value) {
      if (value.length) {
        state.plans = value.map((plan) => {
          plan.name;
          plan.period,
            plan.price,
            plan.use_discount,
            plan.discounted_price,
            (plan.features = JSON.parse(plan.features));
          plan.extras,
            plan.paddle_plan_id,
            (plan.paddle = {
              id: plan.paddle_plan_id,
              vendor: 26610,
            });
          return plan;
        });
      } else {
        state.plans = {
          name: value.name,
          perios: value.period,
          peice: value.price,
          discounted_price: value.discounted_price,
          use_discount: value.use_discount,
          features: JSON.parse(value.features),
          extras: value.extras,
          paddle_plan_id: value.paddle_plan_id,
          paddle: {
            id: value.paddle_plan_id,
            vendor: 26610,
          },
        };
      }
    },
    SET_TITLES_SUBTITLES(state, value) {
      state.title_subtitle = value;
    },
    SET_PAGE(state, value) {
      state.page = value;
      state.nextPage = value + 1;
    },
    NEXT_PAGE(state) {
      state.page = state.page + 1;
      state.nextPage = state.page + 1;
    },
    SET_TOTAL_ADVERTISEMENTS(state, value) {
      state.totalAdvertisements = value;
    },
    SET_TOTAL_TIKTOKS(state, value) {
      state.totalTiktoks = value;
    },
    SET_TOTAL_UGC_CREATORS(state, value) {
      state.totalUGC = value;
    },
    SET_FILTERS(state, value) {
      state.filters = value;
    },
    SET_COLLECTIONS(state, value) {
      state.collections = value;
    },
    SET_COLLECTION_BY_ID(state, value) {
      const index = state.collections.findIndex((item) => item.id === value.id);
      state.collections.splice(index, 1, value);
    },
    DELETE_COLLECTION(state, value) {
      const index = state.collections.findIndex((item) => item.id === value);
      state.collections.splice(index, 1);
    },
    SET_ROLES(state, value) {
      state.roles = value;
    },
    ADD_COLLECTION(state, value) {
      state.collections.unshift(value);
    },
    SET_USERS(state, value) {
      state.users = value;
    },
    SET_TOTAL_USER_COUNT(state, value) {
      state.totalUserCount = value;
    },
    SET_USER_BY_ID(state, value) {
      const index = state.users.findIndex((item) => item.id === value.id);
      state.users.splice(index, 1, value);
    },
    SET_CURRENT_USER(state, value) {
      state.currentUser = value;
    },
  },
  actions: {
    async GET_CURRENT_USER({ state, commit }) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_URL}/user`,
          headers: {
            Authorization: state.token,
          },
        });
        commit('SET_CURRENT_USER', data.data);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GET_USERS({ state, commit }, filters) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_URL}/users`,
          headers: {
            Authorization: state.token,
          },
          params: {
            size: 50,
            page: state.nextPage,
            ...filters,
          },
        });
        commit('SET_USERS', data.data.records);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GET_USER_COUNT({ state, commit }) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_URL}/users/totalCount`,
          headers: {
            Authorization: state.token,
          },
        });
        commit('SET_TOTAL_USER_COUNT', data.count);
      } catch (error) {
        return { success: false, data: 0 };
      }
    },
    async GET_USER_BY_ID({ state }, id) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_URL}/user/${id}`,
          headers: {
            Authorization: state.token,
          },
        });

        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPDATE_USER({ state }, value) {
      try {
        console.log({ value });
        const { data } = await axios({
          method: 'PUT',
          url: `${ADBOX_API_URL}/user1/${value.id}`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });

        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPDATE_USER_COLLECTION({ state }, value) {
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${ADBOX_API_V2_URL}/user/${value.id}`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });

        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPDATE_MEMBERSHIP({ state }, value) {
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${ADBOX_API_V2_URL}/memberships/${value.id}`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });

        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async CHANGE_SUBSCRIPTION_STATUS({ state, commit }, { id, subscription_status }) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_URL}/users/${id}/subscription-status`,
          headers: {
            Authorization: state.token,
          },
          data: {
            subscription_status,
          },
        });

        commit('SET_USER_BY_ID', data.data);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GIVE_FULL_ACCESS({ state, commit }, { id }) {
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${ADBOX_API_URL}/user/${id}/access`,
          headers: {
            Authorization: state.token,
          },
        });
        commit('SET_USER_BY_ID', data.data);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GET_COLLECTIONS({ state, commit }) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_URL}/collections`,
          headers: {
            Authorization: state.token,
          },
        });
        commit('SET_COLLECTIONS', data.data.records);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async CREATE_COLLECTION({ state, commit }) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_URL}/collections`,
          headers: {
            Authorization: state.token,
          },
          data: {
            order: String(Number(state.collections[0].order) + 10),
            public: false,
            title: '',
            is_new: false,
            roles: [],
          },
        });
        commit('ADD_COLLECTION', {
          ...data.data,
          active: true,
          advertisements: [],
        });
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async UPDATE_COLLECTION({ state }, item) {
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${ADBOX_API_URL}/collections/${item.id}`,
          headers: {
            Authorization: state.token,
          },
          data: item,
        });
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async UPDATE_COLLECTION_ADVERTISEMENT({ state }, item) {
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${ADBOX_API_V2_URL}/advertisements-collections/${item.id}`,
          headers: {
            Authorization: state.token,
          },
          data: item,
        });
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async DELETE_COLLECTION({ state, commit }, id) {
      try {
        const { data } = await axios({
          method: 'DELETE',
          url: `${ADBOX_API_URL}/collections/${id}`,
          headers: {
            Authorization: state.token,
          },
        });
        commit('DELETE_COLLECTION', id);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async DELETE_ADVERTISMENT({ state }, id) {
      try {
        const { data } = await axios({
          method: 'DELETE',
          url: `${ADBOX_API_URL}/advertisements/${id}`,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async DELETE_TIKTOK({ state }, id) {
      try {
        const { data } = await axios({
          method: 'DELETE',
          url: `${ADBOX_API_URL}/tiktoks/${id}`,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async DELETE_UGC_CREATORS({ state }, id) {
      try {
        const { data } = await axios({
          method: 'DELETE',
          url: `${ADBOX_API_V2_URL}/ugc-creators/${id}`,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async BULK_INSERT_COLLECTIONS({ state, commit }, item) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_URL}/collections/bulk-insert`,
          headers: {
            Authorization: state.token,
          },
          data: item,
        });
        commit('SET_COLLECTION_BY_ID', { ...item, bulked: true });
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GET_ROLES({ state, commit }) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_URL}/roles`,
          headers: {
            Authorization: state.token,
          },
        });
        commit('SET_ROLES', data.data.records);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GET_ADVERTISEMENTS({ state, commit }, filters) {
      try {
        if (filters) commit('SET_FILTERS', filters);
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_URL}/advertisements_admin?`,
          headers: {
            Authorization: state.token,
          },
          params: {
            size: 50,
            page: state.nextPage,
            ...state.filters,
          },
        });
        commit('SET_TOTAL_ADVERTISEMENTS', data.data.total);
        commit('NEXT_PAGE');
        commit('SET_ADVERTISEMENTS', data.data.results);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GET_TIKTOKS({ state, commit }, filters) {
      try {
        if (filters) commit('SET_FILTERS', filters);
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_URL}/tiktoks?`,
          headers: {
            Authorization: state.token,
          },
          params: {
            size: 50,
            page: state.nextPage,
            ...state.filters,
          },
        });
        commit('SET_TOTAL_TIKTOKS', data.data.total);
        commit('NEXT_PAGE');
        commit('SET_TIKTOKS', data.data.results);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GET_UGC_CREATORS({ state, commit }, filters) {
      try {
        if (filters) commit('SET_FILTERS', filters);
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_V2_URL}/ugc-creators/all`,
          headers: {
            Authorization: state.token,
          },
          params: {
            size: 50,
            page: state.nextPage,
            ...state.filters,
          },
        });
        commit('SET_TOTAL_UGC_CREATORS', data.data.total);
        commit('NEXT_PAGE');
        commit('SET_UGC_CREATORS', data.data);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GET_ADVERTISEMENT_BY_ID({ state }, id) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_URL}/advertisements/${id}`,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async GET_TIKTOK_BY_ID({ state }, id) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_URL}/tiktoks/${id}`,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async GET_UGC_CREATOR_BY_ID({ state }, id) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_V2_URL}/ugc-creators/${id}`,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async GET_MEMBERSHIPS({ commit }) {
      try {
        const response = await axios({
          method: 'GET',
          url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/memberships`,
        });
        commit('SET_MEMBERSHIPS', response.data.memberships);
        return { success: true, data: response.data.memberships };
      } catch (error) {
        console.log('error at membesrship', error);
        return { success: false, data: error.response };
      }
    },
    async GET_MEMBERSHIPS_BY_ID({ commit }, id) {
      try {
        const response = await axios({
          method: 'GET',
          url: `${ADBOX_API_V2_URL}/memberships/${id}`,
        });
        commit('SET_MEMBERSHIPS', response.data.data);
        return { success: true, data: response.data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GET_TITLES_SUBTITLES({ state, commit }, value) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_V2_URL}/titles-subtitles`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });
        commit('SET_TITLES_SUBTITLES', data.data.results);
        return { success: true, data: data.results };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async GET_TITLE_SUBTITLE_BY_ID({ state }, id) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_V2_URL}/titles-subtitles/${id}`,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async DOWNLOAD_USERS({ state }) {
      try {
        const response = await axios({
          method: 'GET',
          url: `${ADBOX_API_V2_URL}/users/download`,
          headers: {
            Authorization: state.token,
          },
          responseType: 'arraybuffer',
        });
        console.log('RES', response);

        return { success: true, data: response };
      } catch (err) {
        return { success: false, data: 'Error' };
      }
    },
    async CREATE_ADVERTISEMENT({ state }, value) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_URL}/advertisements`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async CREATE_TIKTOK({ state }, value) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_URL}/tiktoks`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },

    async CREATE_USER({ state }, value) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_V2_URL}/user1`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPDATE_ADVERTISEMENT({ state }, value) {
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${ADBOX_API_URL}/advertisements/${value.id}`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPDATE_VISIBILITY({ state }, { id, visible }) {
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${ADBOX_API_URL}/advertisements/visibility/${id}`,
          data: { visible: visible },
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async LOAD_FBADS_FROM_QURATION({ state }, value) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${ADBOX_API_URL}/advertisementsLoadFromQuration`,
          headers: {
            Authorization: state.token,
          }
        });
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async UPDATE_TIKTOK({ state }, value) {
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${ADBOX_API_URL}/tiktoks/${value.id}`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPDATE_UGC_CREATORS({ state }, value) {
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${ADBOX_API_V2_URL}/ugc-creators/${value.id}`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async CREATE_UGC_CREATORS({ state }, value) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_V2_URL}/ugc-creators`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPDATE_TITLE_SUBTITLE({ state }, value) {
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${ADBOX_API_V2_URL}/titles-subtitles/edit/${value.id}`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPLOAD_ADVERTISEMENT_MEDIA({ state }, value) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_URL}/advertisements/upload`,
          data: value,
          headers: {
            'Content-Type': `multipart/form-data; boundary=${value._boundary}`,
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPLOAD_TIKTOK_MEDIA({ state }, value) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_URL}/tiktoks/upload`,
          data: value,
          headers: {
            'Content-Type': `multipart/form-data; boundary=${value._boundary} application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,

            'Content-disposition': `attachment; filename=${value.name}`,

            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPLOAD_UGC_CREATORS_MEDIA({ state }, value) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_V2_URL}/ugc-creators/upload`,
          data: value,
          headers: {
            'Content-Type': `multipart/form-data; boundary=${value._boundary} application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
            'Content-disposition': `attachment; filename=${value.name}`,
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPLOAD_UGC_CREATORS_MEDIA_PROFILE({ state }, value) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_V2_URL}/ugc-creators/upload_profile`,
          data: value,
          headers: {
            'Content-Type': `multipart/form-data; boundary=${value._boundary} application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
            'Content-disposition': `attachment; filename=${value.name}`,
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async UPLOAD_TIKTOKS({ state }, value) {
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${ADBOX_API_URL}/tiktoks/import`,
          data: value,
          headers: {
            Authorization: state.token,
          },
        });
        return { success: true, data: data.data };
      } catch (err) {
        return { success: false, data: 'error' };
      }
    },
    async SIGN_IN_WITHOUT_PASSWORD({ state }, { email }) {
      try {
        const response = await axios({
          method: 'POST',
          url: `${ADBOX_API_URL}/signin-without-password`,
          headers: {
            Authorization: state.token,
          },
          data: {
            email,
          },
        });

        Cookies.set('adbox_auth_token', response.data.data.access_token, {
          domain: process.env.VUE_APP_ADBOX_DOMAIN,
          expires: new Date(response.data.data.expires_in),
        });
        Cookies.set('adbox_auth_role', response.data.data.user.role, {
          domain: process.env.VUE_APP_ADBOX_DOMAIN,
          expires: new Date(response.data.data.expires_in),
        });
        window.location.href = process.env.VUE_APP_ADBOX_APP_FRONT_URL;
      } catch (err) {
        return { success: false, data: err.response };
      }
    },
    AUTHENTICATE({ commit }) {
      const token = Cookies.get('adbox_auth_token', {
        domain: process.env.VUE_APP_ADBOX_DOMAIN,
      });
      const role = Cookies.get('adbox_auth_role', {
        domain: process.env.VUE_APP_ADBOX_DOMAIN,
      });
      if (token) {
        commit('SET_TOKEN', token);
        if (!['admin', 'super'].includes(role)) {
          window.location.href = process.env.VUE_APP_ADBOX_APP_FRONT_URL;
        }
      } else {
        window.location.href = process.env.VUE_APP_ADBOX_AUTH_FRONT_URL;
      }
    },
    SIGN_OUT() {
      Cookies.remove('adbox_auth_token', {
        domain: process.env.VUE_APP_ADBOX_DOMAIN,
      });
      Cookies.remove('adbox_auth_role', {
        domain: process.env.VUE_APP_ADBOX_DOMAIN,
      });
      window.location.href = process.env.VUE_APP_ADBOX_FRONT_URL;
    },
  },
  modules: {
    blog,
  },
});
